const appURL = process.env.CFH_APP_URL

const getCFHCalendarUrl = ({ calenderId, slug }: { calenderId: string; slug: string }) => {
  return appURL ? `${appURL}/${slug}/my/calendar/${calenderId}` : ''
}

export default getCFHCalendarUrl
